module.exports = __webpack_public_path__ + "static/erik-fletcher-cannab-agency-headshot-03f211d4d36a64f7083b07eaa8fde793.jpg";